import * as React from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import Rotate3dIcon from 'mdi-react/Rotate3dIcon';
import LiquidacionForm from './liquidacion-form';
import * as moment from 'moment';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MeepoServiceClient from '../../../middleware/meepo-client';
import {ILiquidacion} from '../../../utils/models';
import MeepoState from '../../../reduxstore/meepo-state';
import {Store} from 'react-redux';
import {error} from '../../../utils/notification-actions';
import ReactTable from 'react-table';
import {localCurrency} from '../../../utils/number-utils';
import Panel from '../../../theme/components/Panel';

interface IState {
    data: any[];
}

class LiquidacionView extends React.Component<{}, IState> {

    @lazyInject(TYPES.MEEPO_SERVICE)
    public apiClient: MeepoServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public store: Store<MeepoState>;

    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }

    private get header() {
        return [
            {
                accessor: 'ruta',
                Header: 'Ruta',
                className: 'center liquidacion-data'
            },
            {
                accessor: 'monto',
                Header: 'Monto',
                className: 'right liquidacion-data'
            }
        ]
    }

    public componentDidMount() {
        this.handleObtener(moment());
    }

    public handleObtener = async (values) => {
        const fechaCarga = moment(values.fecha).format('YYYY-MM-DD');
        try {
            const response = await this.apiClient.obtenerLiquidacion(fechaCarga);
            this.setState({
                data: this.transformarData(response)
            });
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error interno al obtener liquidaciones'));
        }
    };

    private transformarData = (liquidacion: ILiquidacion[]) => {
        const content: any[] = [];
        liquidacion.forEach((item) => {
            content.push({
                ruta: item.ruta.descripcion,
                monto: `S/ ${localCurrency(item.monto)}`
            })
        });
        return content;
    };


    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Reporte de liquidación</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <LiquidacionForm onSubmit={this.handleObtener}/>
                    </Col>
                    <Col md={9}>
                        <Panel xs={12} md={12} divider={true} title='Liquidación'>
                            <Col md={12} style={{textAlign: 'right'}}>
                                <Button outline={true} className='icon icon--only'><Rotate3dIcon/></Button>
                            </Col>
                            <ReactTable
                                style={{
                                    margin: 'auto'
                                }}
                                className='rt-custom-table -highlight'
                                columns={this.header} data={this.state.data} showPagination={false}
                                resizable={false}
                                pageSize={this.state.data.length}/>
                        </Panel>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default LiquidacionView;



// WEBPACK FOOTER //
// ./src/components/pages/liquidacion/liquidacion.tsx